import { verdictEmpty } from '@/utils/tools'

export default {
  state: {
    token: '',
    user: {
      uid: 98529,
      name: '翠友82876508321',
      phone: 12888888321,
      display: 1,
      level: 0,
      avatar: '',
      version: '',
      hotUpdate: '',
      easeAcount: '',
      liveWindow: false,
      isNative: false
    },
    statistics: {
      countRed: 0,
      countFollow: 0,
      countCollect: 0,
      countRecord: 0
    }
  },
  mutations: {
    setToken(state, token) {
      state.token = token
    },
    setUser(state, user) {
      state.user.uid = user.uid ? user.uid : 0
      state.user.name = user.name ? user.userName : '翠友82876508321'
      state.user.phone = user.phone ? user.phone : 0
      state.user.avatar = user.avatar ? user.avatar : ''
      state.user = user
    }
  },
  getters: {
    token: state => {
      return state.token
    },
    user: state => {
      return state.user
    },
    statistics: state => {
      return state.statistics
    }
  },
  actions: {
    setUserInfo({ commit }, data) {
      return new Promise(resolve => {
        if (verdictEmpty(data)) {
          return
        }
        commit('setToken', data.userToken || data.token)
        commit('setUser', data)
        resolve(data)
      })
    }
  }
}
